var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDownloadGooglestore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 37,
    viewBox: "0 0 155 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000015437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M50.5209 5.39237C50.5209 6.47787 50.188 7.34725 49.5322 7.99563C48.7783 8.76425 47.7963 9.151 46.5929 9.151C45.4429 9.151 44.4609 8.75775 43.6553 7.98262C42.8481 7.19612 42.4453 6.23087 42.4453 5.0755C42.4453 3.92012 42.8481 2.95488 43.6553 2.17488C44.4609 1.39325 45.4429 1 46.5929 1C47.1655 1 47.7114 1.11538 48.2323 1.32988C48.7516 1.546 49.1744 1.8385 49.4806 2.19925L48.7849 2.885C48.2507 2.26913 47.5233 1.96525 46.5929 1.96525C45.7541 1.96525 45.0268 2.25125 44.4093 2.82812C43.7985 3.40662 43.4922 4.15575 43.4922 5.0755C43.4922 5.99525 43.7985 6.75087 44.4093 7.32937C45.0268 7.89975 45.7541 8.19225 46.5929 8.19225C47.4834 8.19225 48.2323 7.89975 48.8232 7.32287C49.2127 6.941 49.434 6.4145 49.4923 5.74175H46.5929V4.8025H50.4609C50.5075 5.00562 50.5209 5.20225 50.5209 5.39237Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M56.658 2.13584H53.0247V4.60584H56.3002V5.54508H53.0247V8.01508H56.658V8.97221H51.9961V1.17871H56.658V2.13584Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M60.9876 8.97221H59.9591V2.13584H57.7305V1.17871H63.2179V2.13584H60.9876V8.97221Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M67.1895 8.97221V1.17871H68.2164V8.97221H67.1895Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M72.7689 8.97221H71.7486V2.13584H69.5117V1.17871H75.0058V2.13584H72.7689V8.97221Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M85.3947 7.96962C84.6074 8.75775 83.6321 9.151 82.4687 9.151C81.2987 9.151 80.3233 8.75775 79.5361 7.96962C78.7505 7.18312 78.3594 6.21787 78.3594 5.0755C78.3594 3.93312 78.7505 2.96787 79.5361 2.18138C80.3233 1.39325 81.2987 1 82.4687 1C83.6255 1 84.6008 1.39325 85.388 2.18787C86.1803 2.98087 86.5714 3.93962 86.5714 5.0755C86.5714 6.21787 86.1803 7.18312 85.3947 7.96962ZM80.2967 7.31637C80.8892 7.89975 81.6099 8.19225 82.4687 8.19225C83.3209 8.19225 84.0482 7.89975 84.6341 7.31637C85.2249 6.733 85.5245 5.98387 85.5245 5.0755C85.5245 4.16712 85.2249 3.418 84.6341 2.83463C84.0482 2.25125 83.3209 1.95875 82.4687 1.95875C81.6099 1.95875 80.8892 2.25125 80.2967 2.83463C79.7059 3.418 79.4063 4.16712 79.4063 5.0755C79.4063 5.98387 79.7059 6.733 80.2967 7.31637Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M88.0137 8.97221V1.17871H89.262L93.1433 7.23996H93.1882L93.1433 5.74171V1.17871H94.1702V8.97221H93.0983L89.0339 2.61196H88.989L89.0339 4.11671V8.97221H88.0137Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M78.1063 20.354C74.9789 20.354 72.4241 22.6777 72.4241 25.8838C72.4241 29.064 74.9789 31.4121 78.1063 31.4121C81.2403 31.4121 83.7951 29.064 83.7951 25.8838C83.7951 22.6777 81.2403 20.354 78.1063 20.354ZM78.1063 29.2346C76.3903 29.2346 74.914 27.8517 74.914 25.8838C74.914 23.89 76.3903 22.5315 78.1063 22.5315C79.8223 22.5315 81.3052 23.89 81.3052 25.8838C81.3052 27.8517 79.8223 29.2346 78.1063 29.2346ZM65.7084 20.354C62.5743 20.354 60.0262 22.6777 60.0262 25.8838C60.0262 29.064 62.5743 31.4121 65.7084 31.4121C68.8407 31.4121 71.3905 29.064 71.3905 25.8838C71.3905 22.6777 68.8407 20.354 65.7084 20.354ZM65.7084 29.2346C63.9907 29.2346 62.5094 27.8517 62.5094 25.8838C62.5094 23.89 63.9907 22.5315 65.7084 22.5315C67.4243 22.5315 68.9006 23.89 68.9006 25.8838C68.9006 27.8517 67.4243 29.2346 65.7084 29.2346ZM50.9553 22.0488V24.3986H56.7024C56.5343 25.7116 56.0849 26.6768 55.3959 27.3496C54.557 28.1621 53.2505 29.064 50.9553 29.064C47.4185 29.064 44.649 26.2771 44.649 22.824C44.649 19.3708 47.4185 16.584 50.9553 16.584C52.8677 16.584 54.2591 17.3136 55.286 18.2593L56.982 16.6035C55.5457 15.2645 53.635 14.2358 50.9553 14.2358C46.1053 14.2358 42.0293 18.0887 42.0293 22.824C42.0293 27.5592 46.1053 31.4121 50.9553 31.4121C53.5767 31.4121 55.5457 30.5736 57.0936 29.0006C58.6797 27.452 59.174 25.2745 59.174 23.5162C59.174 22.9702 59.1274 22.4681 59.0442 22.0488H50.9553ZM111.282 23.8705C110.815 22.6338 109.372 20.354 106.432 20.354C103.52 20.354 101.095 22.5948 101.095 25.8838C101.095 28.9811 103.495 31.4121 106.712 31.4121C109.313 31.4121 110.815 29.8635 111.432 28.9616L109.501 27.7055C108.857 28.6252 107.98 29.2346 106.712 29.2346C105.452 29.2346 104.548 28.6707 103.969 27.5592L111.544 24.4993L111.282 23.8705ZM103.56 25.7116C103.495 23.5796 105.256 22.4876 106.517 22.4876C107.506 22.4876 108.345 22.9702 108.624 23.6608L103.56 25.7116ZM97.4031 31.0757H99.893V14.8257H97.4031V31.0757ZM93.3253 21.5857H93.2421C92.6829 20.939 91.616 20.354 90.2646 20.354C87.4285 20.354 84.8354 22.785 84.8354 25.9017C84.8354 29.0006 87.4285 31.4121 90.2646 31.4121C91.616 31.4121 92.6829 30.8222 93.2421 30.156H93.3253V30.949C93.3253 33.0631 92.1686 34.199 90.3028 34.199C88.7816 34.199 87.8379 33.1265 87.4484 32.2246L85.2831 33.107C85.9072 34.5727 87.5599 36.3765 90.3028 36.3765C93.2221 36.3765 95.6854 34.6995 95.6854 30.6191V20.6903H93.3253V21.5857ZM90.4776 29.2346C88.7616 29.2346 87.3253 27.8322 87.3253 25.9017C87.3253 23.9533 88.7616 22.5315 90.4776 22.5315C92.1686 22.5315 93.5018 23.9533 93.5018 25.9017C93.5018 27.8322 92.1686 29.2346 90.4776 29.2346ZM122.94 14.8257H116.984V31.0757H119.468V24.9186H122.94C125.697 24.9186 128.402 22.9702 128.402 19.8713C128.402 16.7741 125.691 14.8257 122.94 14.8257ZM123.004 22.6582H119.468V17.0861H123.004C124.859 17.0861 125.917 18.5892 125.917 19.8713C125.917 21.1291 124.859 22.6582 123.004 22.6582ZM138.355 20.3231C136.561 20.3231 134.695 21.0966 133.928 22.811L136.131 23.7128C136.606 22.811 137.478 22.5185 138.4 22.5185C139.688 22.5185 140.995 23.2741 141.015 24.6082V24.7788C140.565 24.5253 139.603 24.15 138.42 24.15C136.047 24.15 133.628 25.4256 133.628 27.8062C133.628 29.9837 135.572 31.3861 137.757 31.3861C139.429 31.3861 140.351 30.65 140.93 29.7936H141.015V31.0497H143.413V24.8162C143.413 21.9351 141.209 20.3231 138.355 20.3231ZM138.055 29.2281C137.243 29.2281 136.111 28.8348 136.111 27.8517C136.111 26.594 137.523 26.1113 138.744 26.1113C139.838 26.1113 140.351 26.347 141.015 26.6573C140.82 28.1621 139.493 29.2281 138.055 29.2281ZM152.151 20.679L149.297 27.7233H149.212L146.261 20.679H143.583L148.017 30.5232L145.487 36.0011H148.082L154.914 20.679H152.151ZM129.767 31.0757H132.257V14.8257H129.767V31.0757Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M1.27959 1.87613C0.888463 2.27588 0.662109 2.89825 0.662109 3.70425V32.4538C0.662109 33.2598 0.888463 33.8821 1.27959 34.2819L1.37613 34.3696L17.8767 18.2659V17.8856L1.37613 1.78188L1.27959 1.87613Z",
    fill: "url(#paint0_linear_8648_10228)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M23.3711 23.6362L17.877 18.2656V17.8854L23.3777 12.5147L23.5009 12.5846L30.0152 16.2035C31.8744 17.2305 31.8744 18.9205 30.0152 19.954L23.5009 23.5664L23.3711 23.6362Z",
    fill: "url(#paint1_linear_8648_10228)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M23.5004 23.5664L17.8764 18.0755L1.2793 34.2817C1.89678 34.9154 2.90373 34.9918 4.04882 34.358L23.5004 23.5664Z",
    fill: "url(#paint2_linear_8648_10228)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M23.5004 12.5848L4.04882 1.79319C2.90373 1.16594 1.89678 1.24231 1.2793 1.87606L17.8764 18.0757L23.5004 12.5848Z",
    fill: "url(#paint3_linear_8648_10228)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8648_10228",
    x1: 16.4117,
    y1: 32.7531,
    x2: -5.39918,
    y2: 10.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8648_10228",
    x1: 32.4361,
    y1: 18.0737,
    x2: 0.217931,
    y2: 18.0737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8648_10228",
    x1: 20.4423,
    y1: 15.0906,
    x2: -9.13506,
    y2: -15.2034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8648_10228",
    x1: -2.89855,
    y1: 43.8466,
    x2: 10.309,
    y2: 30.3191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadGooglestore);
export default __webpack_public_path__ + "static/media/ic-download-googlestore.a17f71c0bb68e0025e3dab376f9e45cb.svg";
export { ForwardRef as ReactComponent };